import { render, staticRenderFns } from "./AdvancedSlotAdding.vue?vue&type=template&id=a8410e9c&scoped=true"
import script from "./AdvancedSlotAdding.vue?vue&type=script&lang=js"
export * from "./AdvancedSlotAdding.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSlotAdding.vue?vue&type=style&index=0&id=a8410e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8410e9c",
  null
  
)

export default component.exports